module.exports = __webpack_public_path__ + "c3b38f86f0f0d8d1b2c080bab62c2cb5.svg";